import { useLocation } from 'react-router-dom';
import { get as _get } from 'lodash';
import { useContext } from 'react';
import { AppContext } from 'commons-ui';

import { GAME_KEY_MAP } from '../../utils/helper';
import useService from '../../utils/useService';

const useKeys = () => {
	const location = useLocation();
	const { app } = useContext(AppContext);
	const { fetchServiceKeys } = useService();
	const { appName } = app;
	const { serviceName } = _get(location.state, 'keysData', '');
	const getServiceKeys = () => {
		return fetchServiceKeys(serviceName, GAME_KEY_MAP[appName]);
	};

	return {
		serviceName,
		getServiceKeys
	};
};

export default useKeys;
